import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const noatoken = localStorage.getItem("noatoken");

  if (!noatoken) {
    return <Navigate to="/login" replace />;
  }

  return children;
}